import ConsignWithUsContainer from "../../../components/pages/other/ConsignWithUs";

const ConsignWithUs = () => {
  return <ConsignWithUsContainer />;
};

export default ConsignWithUs;
